<template>
    <van-popup v-model="popupShow" position="bottom" :lazy-render="false">
        <div class="page bg-fff">
            <appStatus :statusHeight="statusHeight"></appStatus>
            <div class="page-input-title" :style="{top:statusHeight+'rem'}">
                <div class="alifont icon-back left-icon click" @click="back"></div>
                <input type="search" @change="search" class="center-input fs-28" placeholder="搜索小区名" v-model="orgName">
                <div class="right fs-28 color-333 click" @click="search">
                    搜索
                </div>
            </div>
            <div class="pd-25" v-show="!hasKeyword">
                <div class="mt-10 fs-36 font-bold color-333 mb-10">最近选择小区</div>
                <div class="pd-250 fs-32 color-333 bd-bot click" v-for="(item,$index) in historyList" :key="$index" @click="chooseOrg(item)">{{item.orgName}}</div>
                <div class="pd-250 fs-32 color-333 bd-bot" v-if="historyList.length == 0">暂无历史</div>
            </div>
            <div class="pd-25">
                <div class="mt-10 flex-between flex-center mb-10 sticky" :style="{top:(0.9+statusHeight) +'rem'}" v-show="!hasKeyword">
                    <div class="fs-36 font-bold color-333">{{areaName}}</div>
                    <div class="fs-30 color-999 click" @click="$refs.pickerArea.popupShow = true;">切换城市</div>
                </div>
                <div class="pd-250 fs-32 color-333 bd-bot click" v-for="(item,$index) in data" :key="$index" @click="chooseOrg(item)">{{item.orgName}}</div>
                <div class="pd-250 fs-32 color-333 bd-bot" v-if="data.length == 0">暂无小区</div>
            </div>
            <pickerArea ref="pickerArea" @change="areaConfirm"></pickerArea>
        </div>
    </van-popup>
</template>

<script>
    import appStatus from "@/components/appStatus/index"
    import getAppStatusHeight from "@/mixins/getAppStatusHeight";
    import pickerArea from "@/components/picker-area/index"
    import {qryOrgList} from "@/api/shop"
    export default {
        name: "houseQuarterList",
        mixins: [getAppStatusHeight],
        components:{appStatus,pickerArea},
        data(){
            return{
                popupShow:false,
                hasKeyword:false,
                countyId:'440402',
                areaName:'珠海市香洲区',
                historyList: JSON.parse(localStorage.getItem('houseQuarterList')) || [],
                orgName:'',
                data:[],
            }
        },
        created() {
            this.getList()
        },
        methods:{
            back(){
                this.popupShow = false;
            },
            chooseOrg(data){
                let hasHistory = false;
                this.historyList.forEach(item=>{
                    if(item.orgName == data.orgName){
                        hasHistory = true;
                        return
                    }
                });
                if(!hasHistory){
                    if(this.historyList.length >= 4){
                        let arr = this.historyList.slice(1,4);
                        arr.push(data);
                        this.historyList = arr;
                    }else{
                        this.historyList.push(data);
                    }
                    localStorage.setItem('houseQuarterList',JSON.stringify(this.historyList));
                }
                this.$emit('sure',data);
                this.popupShow = false;
            },

            //确定切换城市
            areaConfirm(e){
                console.log(e);
                this.countyId = e[2].areacode;
                this.areaName = e[1].areaname + e[2].areaname;
                this.getList();
            },
            getList(){
                let params = {
                    page:1,
                    limit:50,
                    countyId: this.countyId
                }
                qryOrgList(params).then(res=>{
                    if(res.code == 0){
                        this.data = res.data.records;
                    }
                })
            },
            search(){
                if(!this.orgName){
                    this.hasKeyword = false;
                    this.getList();
                    return
                }else{
                    this.hasKeyword = true;
                }
                let params = {
                    page:1,
                    limit:50,
                    orgName: this.orgName
                }
                qryOrgList(params).then(res=>{
                    if(res.code == 0){
                        this.data = res.data.records;
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .sticky{
        position: sticky;
        position: -webkit-sticky;
        z-index: 20;
        left: 0;
        background: #fff;
    }
</style>



// WEBPACK FOOTER //
// houseQuarterList.vue?563e67a0